/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n){return n}function r(n){return n}export{r as castInstanceId,n as castStrictInstanceId};
